import {
    useState,
    useCallback,
    useEffect,
} from 'react';

import { InteractionType } from '@azure/msal-browser';
import { useMsal, useMsalAuthentication } from "@azure/msal-react";
//import fetchWithLogging from "../middlewares/fetchSetup";

/**
 * Custom hook to call a web API using bearer token obtained from MSAL
 * @param {PopupRequest} msalRequest 
 * @returns 
 */


const useFetch = () => {
    //const { instance } = useMsal();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);
    const [accessTokenAcquired, setAccessTokenAcquired] = useState(null);

    console.log(">> Inside useFetchWithMsal");
    

    //This code works fine when run locally, outside docker environment
    
    // const { result, error: msalError } = useMsalAuthentication(InteractionType.Popup, {
    //     ...msalRequest,
    //     account: instance.getActiveAccount(),
    //     redirectUri: '/redirect'
    // });
    
    
    //This block of code works, and retrieves the accesstoken
    /*
    const {result, error: msalError} = instance.acquireTokenSilent(msalRequest).then(tokenResponse => {
        // Do something with the tokenResponse
        console.log(tokenResponse.accessToken);
    })
    */

    // const getToken = async () => {
    //     try {
    //         const tokenResponse = await instance.acquireTokenSilent(msalRequest);
    //         if (tokenResponse && tokenResponse.accessToken) {
    //             console.log('Access Token:', tokenResponse.accessToken);
    //             return tokenResponse.accessToken;
    //         } else {
    //             console.error('Access Token is null or undefined');
    //             return null;
    //         }
    //     } catch (error) {
    //         console.error('Error acquiring token:', error);
    //         return null;
    //     }
    // };

    // WORKS
    // Non-memoized version without useCallback
    const useAccessToken = () => {
        const { instance, accounts } = useMsal();
        const [accessToken, setAccessToken] = useState(null);
    
        useEffect(() => {
            const acquireToken = async () => {
                if (accounts.length > 0) {
                    const account = accounts[0];
                    try {
                        const response = await instance.acquireTokenSilent({
                            scopes: ["https://ideacoreb2c.onmicrosoft.com/fd0129dc-ac6b-4dee-8df0-41b9f9179159/user.read"],
                            account: account
                        });
                        setAccessToken(response.accessToken);
                        console.log("Token 201: " + accessToken);
                    } catch (error) {
                        console.error("Token acquisition failed:", error);
                        // Handle token acquisition failure (e.g., fallback to interactive token request)
                    }
                }else{
                    console.log("No Accounts Found 101:");
                }
            };
    
            acquireToken();
        }, [instance, accounts, setAccessToken])
    
        // This will log the accessToken whenever it changes
        useEffect(() => {
            if (accessToken) {
                console.log("Token 301: " + accessToken);
                setAccessTokenAcquired(accessToken);
            }
        }, [accessToken]);
    
        return accessToken;
    };

// WORKS
//const accessToken1 = useAccessToken(); // Get the access token from the hook


// Works
// Memoized Version using useCallback
const useAccessTokenMemoized = () => {
    const { instance, accounts   } = useMsal();
    const [accessToken, setAccessToken] = useState(null);
    console.log("Calling 102");
    // Memoize the acquireToken function
    const acquireToken = useCallback(async () => {
        if (accounts.length > 0) {
            const account = accounts[0];
            try {
                const response = await instance.acquireTokenSilent({
                    scopes: ["https://ideacoreb2c.onmicrosoft.com/fd0129dc-ac6b-4dee-8df0-41b9f9179159/user.read"],
                    account: account
                });
                setAccessTokenAcquired(response.accessToken);
                console.log("TokenXX: " + accessToken);
            } catch (error) {
                console.error("Token acquisition failed:", error);
                // Handle token acquisition failure (e.g., fallback to interactive token request)
            }
        }
    }, [instance, accounts]);

    useEffect(() => {
        acquireToken();
    }, [acquireToken]);

    // This will log the accessToken whenever it changes
    useEffect(() => {
        if (accessToken) {
            console.log("Token: " + accessToken);
            setAccessTokenAcquired(accessToken);
        }
    }, [accessToken]);

    return null;
};

// This WORKS
const accessToken1 = useAccessTokenMemoized(); // Get the access token from the hook
    
    const execute = async (method, endpoint, data = null) => {
        console.log("Excuting useFetchWithMsal...");

        if (accessTokenAcquired) {
            try {
                let response = null;

                const headers = new Headers();
                const bearer = `Bearer ${accessTokenAcquired}`;            
                headers.append("Authorization", bearer);

                if (data) headers.append('Content-Type', 'application/json');

                let options = {
                    method: method,
                    headers: headers,
                    body: data ? JSON.stringify(data) : null,
                };

                console.log("BearerToken: " + bearer);

                setIsLoading(true);

                response = await (await fetch(endpoint, options)).json();
                setData(response);

                setIsLoading(false);
                return response;
            } catch (e) {
                setError(e);
                setIsLoading(false);
                throw e;
            }
        }else{
            console.log("Access token is NULL");
            console.log(accessTokenAcquired);
        }
    };

    return {
        isLoading,
        error,
        data,
        execute: useCallback(execute, [accessTokenAcquired]), // to avoid infinite calls when inside a `useEffect`
    };

 };

export default useFetch;